<template>
  <div>
    <DxForm
      :form-data="formData"
      :items="items"
      :label-location="labelLocation"
    >
      <template #form-item="{ data: item }">
        <span class="form-value-style">
          {{ item.editorOptions.value }}
        </span>
      </template>

      <template #form-item-multi-select="{ data: item }">
        <span class="form-value-style">
          {{ getFormattedValue(item.editorOptions.value) }}
        </span>
      </template>

      <template #form-item-rlt="{ data: item }">
        <span class="form-value-style">
          {{ item.editorOptions.value?.name }}
        </span>
      </template>

      <!-- form-item-rlt-dpnd -->

      <template #form-item-rlt-dpnd="{ data: item }">
       
        <span class="form-value-style">
           <DependentDropShowComponent
            v-model="formData[item.dataField]"
            :itemId="item.editorOptions.value"
            :dependentRoute="item.editorOptions.dependentRoute"
            :slug="prifix"
           />
            
        </span>
      </template>

      <template #form-item-user-stamp="{ data: item }">
        <span
          class="form-value-style cursor-pointer text-blue-500"
          @click="onUserStampClick(item.editorOptions.value['id'])"
        >
          {{ item.editorOptions.value["name"] }}
        </span>
      </template>

      <template #form-item-date="{ data: item }">
        <span class="form-value-style">
          {{ getFormattedDate(item.editorOptions.value) }}
        </span>
      </template>

      <template #form-item-dateTime="{ data: item }">
        <span class="form-value-style">
          {{ getFormattedDateTime(item.editorOptions.value) }}
        </span>
      </template>

      <template #form-item-time="{ data: item }">
        <span class="form-value-style">
          {{ getFormattedTime(item.editorOptions.value) }}
        </span>
      </template>

      <template #form-item-invoice="{ data: item }">
        <span class="form-value-style">
          <!-- {{ getFormattedDateTime(item.editorOptions.value) }} -->

          <InvoiceField
            v-model="formData[item.dataField]"
            :fname="item.dataField"
            :modRoute="routeDef"
            :def="item"
            :slug="prifix"
          >
          </InvoiceField>
        </span>
      </template>

      <template #form-line-item="{ data: item }">
        <span class="form-value-style">
          <!-- {{ getFormattedDateTime(item.editorOptions.value) }} -->

          <LineItemField
            v-model="formData.line_items[item.dataField]"
            :fname="item.dataField"
            :modRoute="routeDef"
            :def="item"
            :slug="prifix"
          >
          </LineItemField>
        </span>
      </template>

      
    </DxForm>
  </div>
</template>

<script>
import { DxForm } from "devextreme-vue/form";
import DxDateBox from "devextreme-vue/date-box";
import InvoiceField from "@/components/InvoiceFieldDetailComponent.vue";
import LineItemField from "@/components/LineItemDetailComponent.vue";
import DependentDropShowComponent from "@/components/DependentDropShowComponent.vue";
import axios from 'axios';
//import { getRecordById } from "./builder/base.js";

export default {
  props: {
    createDef: Array,
    routeDef: String,
    prifix: String,
    modelData: {
      type: Object,
      default: () => ({}),
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    DxForm,
    DxDateBox,
    InvoiceField,
    LineItemField,
    DependentDropShowComponent
  },
  data: function () {
    return {
      formData: this.modelData,
      labelLocation: "left",
      items: this.createDef,
      dependentValue:'',
    };
  },
  methods: {
    submit() {
      this.$inertia.post("/" + this.routeDef, this.formData);
    },
    customizeItem(item) {
      item.template = "form-item";
    },

    getFormattedDate(dateString) {
      let date = new Date(dateString);
      let formattedDate = date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      return formattedDate;
    },
   

    getFormattedDateTime(dateString) {
      let date = new Date(dateString);
      let formattedDate = date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
      return formattedDate;
    },

    getFormattedTime(dateTimeString) {
      console.log("We have to format", dateTimeString);
      const date = new Date(dateTimeString);

      // Get hours and minutes
      const hours = date.getHours();
      const minutes = date.getMinutes();

      // Convert to AM/PM format
      const ampm = hours >= 12 ? "PM" : "AM";
      const formattedHours = hours % 12 === 0 ? 12 : hours % 12; // Convert 0 to 12 for 12 AM

      // Pad minutes with leading zero if needed
      const formattedMinutes = (minutes < 10 ? "0" : "") + minutes;

      return `${formattedHours}:${formattedMinutes} ${ampm}`;
    },

    getFormattedValue(arrayString) {
      let array = JSON.parse(arrayString);
      let string = array.join(", ");
      return string;
    },

    onUserStampClick(userId) {
      alert(`ID clicked: ${userId}`);
    },
  },
  mounted() {
    //alert()
    //  console.log("PARENT modelData",this.modelData);
    console.log("PARENT PSSING VALUE ", this.formData);
    console.log("PARENT ITEM VALUE ", this.items);
  },
};
</script>

<style>
.form-value-style {
  font-weight: 600;
}
.dx-form .dx-field-item-label {
  font-size: 12px;

  margin-bottom: 0px;
}
.dx-field-item-label-text {
  color: #827f7f !important;
}

.dx-form-group-with-caption > .dx-form-group-content {
  padding-top: 9px;
  margin-top: 6px;

  /* border-top: none !important; */
  padding-bottom: 15px;
}
.createName {
  background-color: white !important;
  margin-top: 10px;
  padding: 10px 30px;
}
.dx-form-group-caption {
  font-size: 14px;
  font-weight: bold;
  color: #535252;
}
</style>